<template>
	<div style="width: 100%;">
		<PageHeader @back="goback" :content="$t('Quota.Quota')" />
		<div class="quotaBox">
			<div class="addQuota"><el-button size="medium" type="primary" @click="opendialogFormVisible">{{ $t('Quota.AddQuotaOptions') }}</el-button></div>
			<div class="quotaList" v-if="quotaList.length > 0">
				<div v-for="item in quotaList" :key="item.id" class="quotaDataBox">
					<div class="quotaNameBox">
						<div class="quotaName">
							<span class="quotaQuetionLeft" style="display: inline-block;margin-right: 20px;">{{ item.ruleName }}</span>
							<el-tag size="medium">{{item.ruleType == 1 ? $t('Quota.DisplayQuota') : $t('Quota.HideQuota')}}</el-tag>
						</div>
						<div>
							<el-button type="primary" size="small" @click="editNewQuota(item)" class="delquota" style="margin-right: 10px;" icon="el-icon-edit">编辑</el-button>
							<el-popconfirm 

							:title="$t('Quota.deleteIt')" @confirm="delNewQuota(item.id)">
								<el-button  slot="reference" size="small" class="delquota" type="danger" icon="el-icon-delete">删除</el-button>
							</el-popconfirm>
						</div>
					</div>
					<div class="quotaQuetionList">
						<div v-for="optionItem in item.questionnaireNewQuotaDetailsList" :key="optionItem.id" class="quotaQuetion">
							<div class="quotaQuetionLeft">
								<div class="quotaQuetionTitle">{{ optionItem.quotaTitle }}</div>
								<div class="quotaQuetionData">
									<span style="margin-right: 20px;">配额数：<span style="color: #409EFF;">{{ optionItem.quotaNumber }}</span></span>
									<span style="margin-right: 20px;">完成数：<span style="color: #67C23A;">{{ optionItem.quotaFinishNumber }}</span></span>
									<!-- <span style="margin-right: 20px;">完成率：<span style="color: #409EFF;">{{ optionItem.completionRate || 0}}%</span></span> -->
								</div>
							</div>
							<div class="quotaQuetionRight">
								<el-button type="primary" icon="el-icon-edit" @click="editQuotaQuetion(optionItem)" style="margin-right: 10px;" size="small">编辑</el-button>
								<el-popconfirm  :append-to-body="false" :title="$t('Quota.deleteIt')" @confirm="delQuotaQuetion(optionItem)">
									<el-button slot="reference" type="danger" icon="el-icon-delete" size="small">删除</el-button>
								</el-popconfirm>
							</div>
						</div>
					</div>
				</div>
			</div>
			<el-empty v-else />
		</div>

		<!-- 新增配额对话框 -->
		<el-dialog :title="quoatTitle" width="1200px" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
			<el-form :model="form" class="formBox" :rules="rules" ref="ruleForm">
				<el-form-item :label="$t('Quota.RuleName')" :label-width="formLabelWidth" prop="ruleName">
					<el-input size="medium" style="width: 300px;" v-model="form.ruleName" autocomplete="off" :maxlength="25"></el-input>
				</el-form-item>

				<el-form-item :label="$t('Quota.RuleType')" :label-width="formLabelWidth" :label-margin-top="formLabelmarginTop" prop="ruleType">
					<el-radio-group v-model="form.ruleType" style="margin-top:14px">
						<el-radio :style="radioStyle" :label="1">
							<span>{{$t('Quota.DisplayQuota')}}</span>
							<span style="color: rgba(16, 16, 16, 0.4);">{{$t('Quota.DisplayQuotaTip')}}</span>
							<div style="margin-top: 20px;margin-bottom: 20px;">
								<span>{{$t('Quota.QuotaFullTip')}}</span>
								<span>
									<el-input
										style="width: 300px;margin-left: 10px;"
										size="medium"
										v-model="form.ruleText"
										autocomplete="off"
										:maxlength="10"
										:placeholder="$t('Quota.QuotaFullPlaceholder')"
										show-word-limit
									></el-input>
								</span>
							</div>
						</el-radio>
						<el-radio :style="radioStyle" :label="2">
							<span>{{$t('Quota.HideQuota')}}</span>
							<span style="color: rgba(16, 16, 16, 0.4);">{{$t('Quota.HideQuotaTip')}}</span>
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item :label="$t('Quota.RuleCondition1')" :label-width="formLabelWidth" prop="rlueConditionOne">
					<el-select :popper-append-to-body="false" size="medium" style="width: 200px;" v-model="form.rlueConditionOne" :placeholder="$t('Quota.PleaseSelect')" @change="oneChange">
						<el-option v-for="item in options" :key="item.qid" :label="item.questionsName" :value="item.qid">
							<span v-if="item.statusType == 1"><i class="el-icon-s-custom"></i></span>
							<span v-if="item.statusType == 2"><i class="el-icon-question"></i></span>
							<span style="margin-left:5px">{{ item.questionsName }}</span>
						</el-option>
					</el-select>
					<el-button size="medium" style="margin-left: 20px;" @click.prevent="addDomain()">{{$t('Quota.AddConditions')}}</el-button>
				</el-form-item>

				<el-form-item :label="$t('Quota.RuleCondition2')" :label-width="formLabelWidth" v-if="form.rlueConditionTwoShow" prop="rlueConditionTwo">
					<el-select  :popper-append-to-body="false" size="medium" style="width: 200px;" v-model="form.rlueConditionTwo" :placeholder="$t('Quota.PleaseSelect')" @change="oneChangeTwo">
						<el-option v-for="item in options" :key="item.qid" :label="item.questionsName" :value="item.qid">
							<span v-if="item.statusType == 1"><i class="el-icon-s-custom"></i></span>
							<span v-if="item.statusType == 2"><i class="el-icon-question"></i></span>
							<span style="margin-left:5px">{{ item.questionsName }}</span>
						</el-option>
					</el-select>
					<el-button size="medium" style="margin-left: 20px;" @click.prevent="removeDomain()">{{$t('main.delete')}}</el-button>
				</el-form-item>

				<el-form-item :label="$t('Quota.QuotaDetails')" :label-width="formLabelWidth" v-if="form.questionnaireNewQuotaDetailsList.length != 0" prop="questionnaireNewQuotaDetailsList">
					<div class="quota-details">
						<span style="color: rgba(16, 16, 16, 0.4);">{{ $t('Quota.NotSetTotalQuota') }}</span>
						<div>
							<el-input-number size="small" v-model="batchSettingQuotaNum" controls-position="right" :min="0" :precision="0"></el-input-number>
							<el-tooltip class="item" effect="light" content="勾选列表中的配额条件，可批量设置配额数" placement="top">
								<el-button style="margin-left: 10px;" size="small" type="primary" :disabled="quotaDetailsList.length == 0" @click="setBatchSettingQuotaNum">批量设置配额数
									<span v-if="quotaDetailsList.length > 0">（{{ quotaDetailsList.length }}）</span>
								</el-button>
							</el-tooltip>
						</div>
					</div>
					
					<!-- 多个规则条件 -->
					<el-table
						ref="multipleTable"
						:data="form.questionnaireNewQuotaDetailsList"
						tooltip-effect="dark"
						style="width: 100%"
						@selection-change="handleSelectionChange"
						:border="true"
						row-key="rowKey"
					>
						<el-table-column type="selection" width="55"> </el-table-column>
						<el-table-column prop="quotaTitle" label="名称"></el-table-column>
						<el-table-column prop="quotaNumber" label="配额数" width="200">
							<template slot-scope="scope">{{ scope.row.date }}
								<el-input size="small" v-model="scope.row.quotaNumber"></el-input>
							</template>
						</el-table-column>
					</el-table>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="medium" @click="resetForm('ruleForm')" :loading="loading" :disabled="disabled">{{$t('main.cancel')}}</el-button>
				<el-button size="medium" type="primary" @click="addQuotaOk('ruleForm')" :loading="loading" :disabled="disabled">{{$t('main.save')}}</el-button>
			</div>
		</el-dialog>

		<el-dialog :title="$t('Quota.ModifyQuotaCount')" :visible.sync="editQuotaQuetionVisible" width="600px" :close-on-click-modal="false">
			配额数：<el-input-number controls-position="right"  v-model="editQuotaNum" :min="1" :max="100000" size="medium" :label="$t('Quota.PleaseEnterModifyQuotaCount')"></el-input-number>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="editQuotaQuetionVisible = false">{{$t('main.cancel2')}}</el-button>
				<el-button :loading="editQuotaLoading" size="medium" type="primary" @click="editQuotaQuetionOk">{{$t('main.ok2')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { InterceptMiddle } from '../myQuestionnaire/js/regular';
import PageHeader from '@/components/pageHeader.vue';
export default {
	components: {
		PageHeader
	},
	data() {
		var checkQuotaList = (rule, value, callback) => {
			console.log('value :>> ', value);
			if (value.length == 0) {
				return callback(new Error('配额数量不能为空！'));
			}
			callback()
		};
		return {
			loading: false,
			disabled: false,
			quoatType: 1, //新增修改状态
			quoatTitle: this.$t('Quota.AddQuotaRules'), //
			editData: {}, //要修改的配额
			editQuotaNum: '', //配额数
			editQuotaQuetionVisible: false, //修改单个配额数
			id: '',
			tempQution: [],
			tempQution2: [],
			options: [],
			radioStyle: {
				display: 'block'
				// height: '30px',
				// lineHeight: '30px',
			},
			dynamicValidateForm: {
				email: ''
			},
			form: {
				ruleName: '', //规则名称
				ruleType: 1, //规则类型(1显示配额，2隐示配额)
				ruleText: '', //规则类型对应的提示文本
				rlueConditionOne: '', //规则条件1
				rlueConditionTwo: '', //规则条件2
				ruleConditionOneTitle: '', //规则条件1的题号
				ruleConditionOneType: '', //规则类型(1样本，2题)
				ruleConditionTwoTitle: '', //规则条件2的题号
				ruleConditionTwoType: '', //规则类型(1样本，2题)
				rlueConditionTwoShow: false, //显示不显示
				questionnaireNewQuotaDetailsList: []
			},
			rules: {
				ruleName: [
					{ required: true, message: '配额名称不能为空！', trigger: 'blur,change' }
				],
				ruleType: [
					{ required: false }
				],
				ruleText: [
					{ required: false }
				],
				rlueConditionOne: [
					{ required: true, message: '规则条件1不能为空！', trigger: 'blur,change' }
				],
				rlueConditionTwo: [
					{ required: false }
				],
				ruleConditionOneTitle: [
					{ required: false }
				],
				ruleConditionOneType: [
					{ required: false }
				],
				ruleConditionTwoTitle: [
					{ required: false }
				],
				ruleConditionTwoType: [
					{ required: false }
				],
				rlueConditionTwoShow: [
					{ required: false }
				],
				questionnaireNewQuotaDetailsList: [
					{ validator: checkQuotaList, trigger: 'blur,change' }
				],
			},
			formLabelWidth: '130px',
			formLabelmarginTop: '-12px',
			dialogFormVisible: false,
			quotaList: [],
			editQuotaLoading: false,
			conditionOneData: null, // 存储第一个条件的完整数据
			conditionTwoData: null, // 存储第二个条件的完整数据
			quotaDetailsList: [],
			batchSettingQuotaNum: 0
		};
	},
	computed: {
		selectIndex() {
			let state;
			if (this.$route.query.source == 'df') {
				state = 3;
			} else if (this.$route.query.source == 'mf') {
				state = 4;
			}
			return state;
		}
	},
	created() {
		this.id = this.$route.query.id;
		this.loadData();
	},
	methods: {
		resetForm(formName) {
			this.dialogFormVisible = false		
			this.batchSettingQuotaNum = 0					
			this.rlueConditionOneOne = '';
			this.rlueConditionOneTwo = '';
			this.rlueConditionTwoOne = '';
			this.rlueConditionTwoTwo = '';
			this.quotaDetailsList = []
        	this.$refs[formName].resetFields();
		},
		setBatchSettingQuotaNum() {
			this.quotaDetailsList.forEach(info => {
				info.quotaNumber = this.batchSettingQuotaNum
				
				this.form.questionnaireNewQuotaDetailsList.forEach(el => {
					if (el.rowKey == info.rowKey){
						el.quotaNumber = this.batchSettingQuotaNum
					}
				});
			});
		},
		handleSelectionChange(val) {
			this.quotaDetailsList = val
		},
		// 向下填充
		fillDown(value, list, index, verticalIndex) {
			for (let i = index; i < list.length; i++) {
				list[i].ColumnList[verticalIndex].quotaNumber = value || 1;
			}
			this.$forceUpdate();
		},
		// 修改
		editNewQuota(value) {
			// console.log(value);
			this.quoatTitle = this.$t('Quota.ModifyQuotaRules');
			this.quoatType = 2; //修改
			this.loadDataList();

			setTimeout(() => {
				this.form = JSON.parse(JSON.stringify(value));
				this.form.ruleType = Number(this.form.ruleType);
				if (this.form.rlueConditionTwo != '') {
					this.form.rlueConditionTwoShow = true; //显示不显示
				} else {
					this.form.rlueConditionTwoShow = false; //显示不显示
				}
				Promise.all([this.oneChange(this.form.rlueConditionOne), this.oneChangeTwo(this.form.rlueConditionTwo)])
						.then(() => {
							//两个都调成功以后执行的操作
							console.log(this.form);
							this.dialogFormVisible = true;
							this.$nextTick(() => {
								value.questionnaireNewQuotaDetailsList.forEach((info => {
									this.$set(info, 'rowKey', `${info.optionOneCondition}_${info.optionTwoCondition}`)
								}))
								this.toggleSelection( value.questionnaireNewQuotaDetailsList )
							})
							//主要是loading问题
						})
						.catch(err => {
							// 抛出错误信息
							console.log(err);
						});
			}, 500);
		},
		toggleSelection(rows) {
			console.log('rows :>> ', rows);
			if (rows) {
				rows.forEach(row => {
					const targetRow = this.form.questionnaireNewQuotaDetailsList.find(info => {
						let rowKey = ''
						if (info.optionTwoCondition) {
							rowKey = `${info.optionOneCondition}_${info.optionTwoCondition}`
						} else {
							rowKey = `${info.optionOneCondition}_`
						}
						return rowKey === row.rowKey
					});
					if (targetRow) {
						targetRow.quotaNumber = row.quotaNumber;
						this.$refs.multipleTable.toggleRowSelection(targetRow);
					}
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		editQuotaQuetionOk() {
			if (this.editQuotaNum == undefined || this.editQuotaNum == 0) {
				this.$message.warning(this.$t('Quota.PleaseEnterNumberQuotasModify'));
				return false;
			}
			this.editQuotaLoading = true
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.modifyChildQuota}`,
				method: 'POST',
				data: {
					id: this.editData.id,
					quotaNumber: this.editQuotaNum
				},
				cb(res) {
					if (res.code == 0) {
						that.loadData();
						that.$message({
							message: res.message,
							type: 'success'
						});
						that.editQuotaNum = '';
						that.editQuotaQuetionVisible = false;
					} else {
						that.$message.error(res.message);
					}
				},
				finally() {
					that.editQuotaLoading = false
				}
			};
			this.$util.request(params);
		},
		editQuotaQuetion(value) {
			this.editData = JSON.parse(JSON.stringify(value));
			this.editQuotaNum = this.editData.quotaNumber;
			this.editQuotaQuetionVisible = true;
		},
		delQuotaQuetion(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.delChildQuota}`,
				method: 'POST',
				data: {
					id: value.id,
					qid: that.id
				},
				cb(res) {
					if (res.code == 0) {
						that.loadData();
						that.$message({
							message: that.$t('Quota.SuccessfullyDeleted'),
							type: 'success'
						});
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		input(value, e) {
			this.$forceUpdate();
		},
		delNewQuota(id) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.delNewQuota}`,
				method: 'POST',
				data: {
					id: id
				},
				cb(res) {
					if (res.code == 0) {
						that.loadData();
						that.$message({
							message: res.message,
							type: 'success'
						});
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		querySamplValueByEnfieldName(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.querySamplValueByEnfieldName}`,
				method: 'POST',
				data: {
					qid: that.id,
					enfieldName: value
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		oneChangeTwo(value) {
			let that = this;
			let questionsType = 1;
			
			// 确定问题类型
			that.options.forEach(item => {
				if (item.qid == value) {
				questionsType = item.id == '' ? 1 : 2;
				}
			});
			
			return new Promise((resolve, reject) => {
				if (questionsType == 2) {
				// 问题类型条件
				let selectedQuestion = null;
				that.options.forEach(item => {
					if (item.qid == value) {
					selectedQuestion = item;
					that.form.ruleConditionTwoTitle = that.delHtmlTag(item.questionsName);
					that.form.ruleConditionTwoType = item.statusType;
					}
				});
				
				if (!selectedQuestion) {
					reject('未找到对应的问题');
					return;
				}
				
				// 存储第二个条件数据
				that.conditionTwoData = {
					type: 'question',
					qid: selectedQuestion.qid,
					questionName: that.delHtmlTag(selectedQuestion.questionsName),
					options: selectedQuestion.optionJson.map(opt => ({
					labelName: opt.labelName,
					conditionValue: opt.oid
					}))
				};
				
				// 生成最终结构
				that.generateFinalQuotaStructure();
				resolve();
				
				} else {
				// 样本类型条件
				let params = {
					that: this,
					url: `${this.$config.service.querySamplValueByEnfieldName}`,
					method: 'POST',
					data: {
					qid: that.id,
					enfieldName: value
					},
					cb(res) {
						if (res.code == 0) {
							let selectedQuestion = null;
							that.options.forEach(item => {
								if (item.qid == value) {
									selectedQuestion = item;
									that.form.ruleConditionTwoTitle = that.delHtmlTag(item.questionsName);
									that.form.ruleConditionTwoType = item.statusType;
								}
							});
							
							if (!selectedQuestion) {
								reject('未找到对应的问题');
								return;
							}
							
							// 存储第二个条件数据
							that.conditionTwoData = {
								type: 'sample',
								qid: selectedQuestion.qid,
								questionName: that.delHtmlTag(selectedQuestion.questionsName),
								options: res.resultBody.map(item => ({
									labelName: item,
									conditionValue: item
								}))
							};
							
							// 生成最终结构
							that.generateFinalQuotaStructure();
							
						} else {
							that.conditionTwoData = null
							
							// 生成最终结构
							that.generateFinalQuotaStructure();
						}
						resolve();
					}
				};
				this.$util.request(params);
				}
			});
		},
		oneChange(value) {
			let that = this;
			let questionsType = 1;
			// 确定问题类型
			that.options.forEach(item => {
				if (item.qid == value) {
				questionsType = item.id == '' ? 1 : 2;
				}
			});
			
			return new Promise((resolve, reject) => {
				if (questionsType == 2) {
				// 问题类型条件
				let selectedQuestion = null;
				that.options.forEach(item => {
					if (item.qid == value) {
					selectedQuestion = item;
					that.form.ruleConditionOneTitle = that.delHtmlTag(item.questionsName);
					that.form.ruleConditionOneType = item.statusType;
					}
				});
				
				if (!selectedQuestion) {
					reject('未找到对应的问题');
					return;
				}
				
				// 存储第一个条件数据
				that.conditionOneData = {
					type: 'question',
					qid: selectedQuestion.qid,
					questionName: that.delHtmlTag(selectedQuestion.questionsName),
					options: selectedQuestion.optionJson.map(opt => ({
					labelName: opt.labelName,
					conditionValue: opt.oid,
					quotaTitle: `${that.delHtmlTag(selectedQuestion.questionsName)}：「${opt.labelName}」`
					}))
				};
				
				// 生成最终结构
				that.generateFinalQuotaStructure();
				resolve();
				
				} else {
				// 样本类型条件
				let params = {
					that: this,
					url: `${this.$config.service.querySamplValueByEnfieldName}`,
					method: 'POST',
					data: {
					qid: that.id,
					enfieldName: value
					},
					cb(res) {
						if (res.code == 0) {
							let selectedQuestion = null;
							that.options.forEach(item => {
							if (item.qid == value) {
								selectedQuestion = item;
								that.form.ruleConditionOneTitle = that.delHtmlTag(item.questionsName);
								that.form.ruleConditionOneType = item.statusType;
							}
							});
							
							if (!selectedQuestion) {
							reject('未找到对应的问题');
							return;
							}
							
							// 存储第一个条件数据
							that.conditionOneData = {
								type: 'sample',
								qid: selectedQuestion.qid,
								questionName: that.delHtmlTag(selectedQuestion.questionsName),
								options: res.resultBody.map(item => ({
									labelName: item,
									conditionValue: item,
									quotaTitle: `${that.delHtmlTag(selectedQuestion.questionsName)}：「${item}」`
								}))
							};
							
							// 生成最终结构
							that.generateFinalQuotaStructure();
						} else {
							that.conditionOneData = null
							that.generateFinalQuotaStructure();
						}
						resolve();
					}
				};
				this.$util.request(params);
				}
			});
		},
		generateFinalQuotaStructure() {
			const that = this;
			const finalList = [];
			
			if (that.conditionOneData && !that.conditionTwoData) {
				// 只有第一个条件 - 单条件配额
				that.conditionOneData.options.forEach(opt1 => {
					finalList.push({
						quotaTitle: opt1.quotaTitle,
						optionOneCondition: opt1.conditionValue,
						optionTwoCondition: '',
						quotaNumber: 1, // 等待用户输入
						rowKey:  `${opt1.conditionValue}_`
					});
				});
				
			} else if (that.conditionOneData && that.conditionTwoData) {
				// 两个条件 - 交叉配额
				that.conditionOneData.options.forEach(opt1 => {
				that.conditionTwoData.options.forEach(opt2 => {
					finalList.push({
							quotaTitle: `${opt1.quotaTitle} ${that.conditionTwoData.questionName}：「${opt2.labelName}」`,
							optionOneCondition: opt1.conditionValue,
							optionTwoCondition: opt2.conditionValue,
							quotaNumber: 1, // 等待用户输入
							rowKey:  `${opt1.conditionValue}_${opt2.conditionValue}`
						});
					});
				});
			}
			
			that.form.questionnaireNewQuotaDetailsList = finalList;
		},
		getSubmitData() {
			return this.form.questionnaireNewQuotaDetailsList.filter(item => 
				item.quotaNumber && item.quotaNumber !== '' && !isNaN(item.quotaNumber)
			).map(item => ({
				...item,
				quotaNumber: parseInt(item.quotaNumber) || 1
			}));
		},
		delHtmlTag(str) {
			return str.replace(/<[^>]+>/g, ''); //去掉所有的html标记
		},
		opendialogFormVisible() {
			this.quoatTitle = this.$t('Quota.AddQuotaRules');
			this.quoatType = 1; //新增
			this.form = {
				ruleName: '', //规则名称
				ruleType: 1, //规则类型(1显示配额，2隐示配额)
				ruleText: '', //规则类型对应的提示文本
				rlueConditionOne: '', //规则条件1
				rlueConditionTwo: '', //规则条件2
				ruleConditionOneTitle: '', //规则条件1的题号
				ruleConditionOneType: '', //规则类型(1样本，2题)
				ruleConditionTwoTitle: '', //规则条件2的题号
				ruleConditionTwoType: '', //规则类型(1样本，2题)
				rlueConditionTwoShow: false, //显示不显示
				questionnaireNewQuotaDetailsList: []
			};
			this.loadDataList();
			this.dialogFormVisible = true;
		},
		loadDataList() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryQuess}?id=${this.id}`,
				method: 'GET',
				cb(res) {
					if (res.code == 0) {
						let quotaList = res.resultBody;
						quotaList.forEach((item, index) => {
							if (item.id != '') {
								item.statusType = 2;
							} else {
								item.statusType = 1;
							}
							if (item.optionJson != '') {
								item.optionJson = JSON.parse(item.optionJson);
							}

							item.questionsName = item.questionsName.replace(/<[^>]+>/g, '');
						});
						that.options = quotaList;
					} else {
						that.options = [];
					}
				}
			};
			this.$util.request(params);
		},
		removeDomain() {
			this.tempQution2 = [];
			this.form.rlueConditionTwo = '';
			this.form.rlueConditionTwoShow = false;
			this.form.ruleConditionTwoTitle = ''
			this.form.ruleConditionTwoType = ''
			this.oneChangeTwo()
		},
		addDomain() {
			this.form = Object.assign({}, this.form, { rlueConditionTwoShow: true });
		},
		addQuotaOk(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.loading = true;
					this.disabled = true;
					let data = JSON.parse(JSON.stringify(this.form));

					if (this.quotaDetailsList.length > 0) {
						data.questionnaireNewQuotaDetailsList = this.quotaDetailsList
					}
					data.questionnaireNewQuotaDetailsList = data.questionnaireNewQuotaDetailsList.map((info) => {
						return info = {
							optionOneCondition: info.optionOneCondition,
							optionTwoCondition: info.optionTwoCondition,
							quotaNumber: info.quotaNumber,
							quotaTitle: info.quotaTitle										
						}
					})
					data.qid = this.id;
					// 切换新增修改
					let url = `${this.$config.service.saveQuota}`;
					if (this.quoatType == 1) {
						url = `${this.$config.service.saveQuota}`;
					} else {
						url = `${this.$config.service.modifyQuota}`;
					}

					let that = this;
					let params = {
						that: this,
						url: url,
						method: 'POST',
						data: data,
						cb(res) {
							if (res.code == 0) {
								that.loading = false;
								that.disabled = false;
								that.$message({
									message: res.message,
									type: 'success'
								});
								that.loadData();
								that.resetForm(formName)
	
							} else {
								that.loading = false;
								that.disabled = false;
								that.$message.error(res.message);
							}
						}
					};
					this.$util.request(params);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
			
		},
		loadData() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryQuota}`,
				method: 'POST',
				data: {
					qid: that.id
				},
				cb(res) {
					if (res.code == 0) {
						that.quotaList = res.resultBody;
					} else {
						that.quotaList = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		goback() {
			if (this.$route.query.type) {
				setTimeout(() => {
					this.$router.replace({ path: '/questionSetting', query: { typeId: 2 } });
				}, 0);
			} else {
				this.$router.go(-1)
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.details_header {
	// max-width: 1200px;
	height: 60px;
	line-height: 60px;
	text-align: center;
	background-color: #0080ff;
	margin: auto;
	display: flex;
	justify-content: space-between;
	span {
		// color: #333333;
		color: #fff;
		font-size: 16px;
		padding: 0px 30px;
	}
	margin-bottom: 20px;
	cursor: pointer;
}
.quotaBox {
	padding: 0 20px 20px 20px;
	width: 1200px;
	box-sizing: border-box;
	margin: 0 auto;
	.addQuota {
		text-align: right;
		margin-bottom: 20px;
	}
	.quotaList {
		.quotaDataBox {
			min-height: 250px;
			border: 1px solid #EBEEF5;
			margin-bottom: 30px;
			border-radius: 4px;
			.quotaNameBox {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 20px;
				box-sizing: border-box;
				border-bottom: 1px solid #EBEEF5;
				background-color: #f5f7fa;
				.quotaName {
					display: flex;
					justify-content: space-between;
					align-items: center;
				}
				.quotaQuetionLeft {
					height: 24px;
					max-width: 700px;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 1;
					overflow: hidden;
					white-space: nowrap; /* 防止文本换行 */
					text-overflow: ellipsis; /* 显示省略号来代表被修剪的文本 */
				}
			}
			.quotaRule {
				height: 30px;
				line-height: 30px;
				margin-bottom: 20px;
				display: flex;
				.quotaRuleTypeBtn {
					margin-left: 10px;
				}
			}
			.quotaQuetionList {
				.quotaQuetion {
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 20px;
					.quotaQuetionLeft {
						width: 700px;
						.quotaQuetionTitle {
							max-width: 700px;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 1;
							overflow: hidden;
							margin-bottom: 5px;
						}
						.quotaQuetionData{
							font-size: 14px;
							color: #606266;
						}
					}
					.quotaQuetionRight {
					}
				}
				.quotaQuetion+.quotaQuetion{
					border-top: 1px solid #EBEEF5;
				}
			}
		}
	}
}
.quota-details{
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 10px;
}
// 新增配额
.formBox {
	.quotaParticulars {
		min-width: 344px;
		min-height: 139px;
		border: 1px solid #bbbbbb;
		.table_tr {
			.table_td {
				padding: 8px;
				text-align: center;
			}
			.table_displayTd {
				position: relative;
				.table_displayTdBtn {
					position: absolute;
					top: 8px;
					right: 8px;
				}
			}
		}
	}
}
</style>
